import * as QrWaiter from "./QrWaiter";
import { getDataBySelector } from "../utils/getDataBySelector";
import { getMobileAppType } from "../utils/getMobileAppType";
// Deep import, not the `restaumatic-client` barrel: this loads on every page via app.js.
import { VoiceOrderHandoffStorageManager } from "restaumatic-client/src/storageBase/VoiceOrderHandoffStorageManager";
/**
 * The menu consumer of this page visit. Keep it in line with the consumer `RestaumaticClient`
 * picks for the sales channel, or the page and the client hide different menu items.
 */
export function currentMenuConsumer() {
    if (QrWaiter.isQrWaiterOrder()) {
        return "QrWaiter";
    }
    if (getMobileAppType() !== null) {
        return "MobileApp";
    }
    const rawRestaurantId = getDataBySelector("data-cart-restaurant-id", "cartRestaurantId");
    if (rawRestaurantId !== null &&
        VoiceOrderHandoffStorageManager.validToken(parseInt(rawRestaurantId)) !==
            null) {
        return "VoiceOrder";
    }
    return "Site";
}
/**
 * Interpret `data-visible-in` attribute on menu elements, i.e. hide elements not visible in current MenuConsumer.
 */
export function applyMenuVisibleIn() {
    const menuConsumer = currentMenuConsumer();
    for (const elem of document.querySelectorAll("[data-visible-in]")) {
        const visibleIn = elem
            .getAttribute("data-visible-in")
            .split(",");
        if (visibleIn.indexOf(menuConsumer) === -1) {
            elem.style.display = "none";
            elem.classList.remove("js-group-item");
        }
    }
}
